import { render, staticRenderFns } from "./SsCard.vue?vue&type=template&id=effb7696&scoped=true"
import script from "./SsCard.vue?vue&type=script&lang=js"
export * from "./SsCard.vue?vue&type=script&lang=js"
import style0 from "./SsCard.vue?vue&type=style&index=0&id=effb7696&prod&lang=scss&scoped=true"
import style1 from "./SsCard.vue?vue&type=style&index=1&id=effb7696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effb7696",
  null
  
)

export default component.exports